export class WebhookV1StandardPayloadRestoreJobSucceededArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreJobSucceeded",
            "baseName": "restoreJobSucceeded",
            "type": "WebhookV1RestoreJobSucceededArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadRestoreJobSucceededArguments.attributeTypeMap;
    }
    constructor() {
    }
}
